<template>
  <div>
    <div class="cert-header d-flex py-4">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large mt-3 mt-xl-0">Report Incident</div>
      </div>
    </div>
    <div ref="message" class="col-12 col-md-11 col-lg-10 col-xl-9 cert-announcement my-4 mx-auto py-3 px-4">You can
      contact us directly at <strong>incident@ncsa.gov.rw</strong>
      <strong>
        <a href="//cyber.gov.rw/index.php?eID=dumpFile&t=f&f=335&token=511c8f3fdc72246b8c8995dff6718928404bbce9"
           target="_blank" style="width: fit-content">
          <micon icon="file_download" class="material-icons-outlined"/>
          <span style="margin-left: 8px">PGP Key</span>
        </a>
        <router-link :to="{path: '/guide/incident'}" style="width: fit-content">
          <micon icon="help_outline" class="material-icons-outlined"/>
          <span style="margin-left: 8px">Cyber Incident Reporting Guide</span>
        </router-link>
      </strong>
    </div>
    <div ref="content"
         class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-3 cert-page-content d-flex">
      <form class="row g-3 mt-0 mx-auto" @submit="reportIncident">
        <argon-alert class="alert-success alert-dismissible" v-if="responseSuccess">
          Incident reported successfully
        </argon-alert>
        <argon-alert class="alert-danger alert-dismissible" v-if="responseError">
          Something went wrong
        </argon-alert>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">First Name</label>
          <input :disabled="disableSubmit" type="text" class="form-control" id="inputEmail4" v-model="first_name">
          <div v-if="!validation.first_name.status" style="color: red">{{ validation.first_name.message }}</div>
        </div>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">Last Name</label>
          <input :disabled="disableSubmit" type="text" class="form-control" id="inputEmail4" v-model="last_name">
          <div v-if="!validation.last_name.status" style="color: red">{{ validation.last_name.message }}</div>
        </div>
        <div class="col-md-6">
          <label for="inputPassword4" class="form-label required">Telephone</label>
          <input :disabled="disableSubmit" type="text" class="form-control" id="inputPassword4" v-model="phone_number"
                 :class="{ valid: isValidPhoneNumber, invalid: !isValidPhoneNumber }">
          <div v-if="!validation.phone_number.status" style="color: red">{{ validation.phone_number.message }}</div>

        </div>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">Email</label>
          <input :disabled="disableSubmit" type="email" class="form-control" id="inputEmail4" v-model="reporter_email">
          <div v-if="!validation.reporter_email.status" style="color: red">{{ validation.reporter_email.message }}</div>
        </div>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">Organization Name</label>
          <input :disabled="disableSubmit" type="text" class="form-control" id="inputEmail4"
                 v-model="organization_name">
          <div v-if="!validation.organization_name.status" style="color: red">{{
              validation.organization_name.message
            }}
          </div>
        </div>
        <div class="col-md-6">
          <label for="inputState" class="form-label required ">Organization Sector</label>
          <select :disabled="disableSubmit" id="inputState" class="form-select" v-model="organization_sector">
            <option v-for="item in organizationSectorList" :key="item" :value="item">
              {{ item }}
            </option>

          </select>
          <div v-if="!validation.organization_sector.status" style="color: red">
            {{ validation.organization_sector.message }}
          </div>
        </div>
        <div class="col-md-6">
          <label for="inputState" class="form-label required ">Incident Type</label>
          <select :disabled="disableSubmit" id="inputState" class="form-select" v-model="incident_type"
                  style="text-transform: capitalize">
            <option v-for="item in incidentTypeList" :key="item.val" :value="item.val">
              {{ item.display }}
            </option>
            <option>other</option>

          </select>
          <div v-if="!validation.incident_type.status" style="color: red">{{ validation.incident_type.message }}</div>
        </div>
        <div class="col-md-6" v-if="incident_type ==='WEB_APPLICATION_ATTACK'">
          <label for="inputState" class="form-label required ">Hosted in Country</label>
          <irt-input-select :options="countries" v-model="hostingCountry"/>
          <div v-if="!validation.hostingCountry.status" style="color: red">
            {{ validation.hostingCountry.message }}
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="incident_type =='other'">
            <label for="inputEmail4" class="form-label">Description of incident Type</label>
            <input type="text" class="form-control" id="inputEmail4" v-model="anotherIncident_type"
                   :disabled="incident_type !='other' || disableSubmit">
          </div>
        </div>
        <h6 class="mb-0 py-0">When was this incident detected?</h6>
        <div class="col-md-12 mt-0">
          <label for="inputCity" class="form-label required">Date</label>
          <div id="datepicker" class=" date">
            <date-picker :disabled="disableSubmit" v-model:value="detection_date" type="datetime" :format="myFormat"
                         :use12h="true"
                         form-control></date-picker>
            <div v-if="!validation.detection_date.status" style="color: red">{{
                validation.detection_date.message
              }}
            </div>

          </div>
        </div>
        <div class="col-12">
          <label for="inputAddress2" class="form-label required">Description of the incident</label>
          <textarea :disabled="disableSubmit" class="form-control" aria-label="With textarea"
                    v-model="incident_description"></textarea>
          <div v-if="!validation.incident_description.status" style="color: red">
            {{ validation.incident_description.message }}
          </div>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-primary" :disabled="disableSubmit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import IrtInputSelect from "./components/IrtInputSelect";
import ArgonAlert from "@/components/ArgonAlert";
import validators from "@/assets/helper/validators";

export default {
  name: "incidentform",
  props: {
    getApplicationObj: {
      type: Function
    }
  }, components: {
    ArgonAlert,
    DatePicker,
    IrtInputSelect,
  },
  data() {
    return {
      countries: [],
      myFormat: "YYYY-MM-DD HH:mm",
      detection_date: null,
      detection_time: null,
      time: null,
      incident_description: null,
      anotherIncident_type: null,
      incident_type: null,
      organization_sector: null,
      organization_name: null,
      reporter_email: null,
      phone_number: null,
      last_name: null,
      first_name: null,
      disabled: null,
      organizationSectorList: [],
      incidentTypeList: [],
      applicationId: null,
      isValidPhoneNumber: true,
      responseSuccess: false,
      responseError: false,
      reCaptchaResponse: false,
      reCaptchaError: false,
      disableSubmit: false,
      hostingCountry: null,
      validation: {
        first_name: {status: true, message: null},
        last_name: {status: true, message: null},
        organization_sector: {status: true, message: null},
        phone_number: {status: true, message: null},
        reporter_email: {status: true, message: null},
        organization_name: {status: true, message: null},
        incident_type: {status: true, message: null},
        detection_date: {status: true, message: null},
        incident_description: {status: true, message: null},
        hostingCountry: {status: true, message: null}
      }
    };
  },
  methods: {
    verifyMethod() {
      this.reCaptchaResponse = true;
      this.reCaptchaError = false;
    },
    expiredMethod() {
      this.reCaptchaResponse = false;
    },
    errorMethod() {
      this.reCaptchaResponse = false;
    },
    formatDatetime(datetime) {
      if (datetime === null) {
        return "[null]";
      } else {
        return datetime.format("YYYY-MM-DD HH:mm:ss");
      }
    },
    loadIncidentType() {
      axios.get(
          `${process.env.VUE_APP_BASE_URL}incident/types`
      )
          .then((response) => {
            this.incidentTypeList = response.data.map(item => {
              let a = {};
              a.val = item;
              a.display = item.replaceAll("_", " ").toLowerCase();
              return a;
            });
            this.incident_type = this.incidentTypeList[0].val;
          });
    },
    loadOrganizationSector() {
      axios.get(`${process.env.VUE_APP_BASE_URL}sector`)
          .then((response) => {
            this.organizationSectorList = response.data;
            this.organization_sector = this.organizationSectorList[0].id;
          });
    },
    validationReportIncidentStatus() {
      this.validation.first_name = validators.validateText("First name", this.first_name);
      this.validation.last_name = validators.validateText("Last name", this.last_name);
      this.validation.organization_sector = validators.validateText("Organization sector", this.organization_sector);
      this.validation.phone_number = validators.validatePhoneNumber(this.phone_number);
      this.validation.reporter_email = validators.validateEmailAddress(this.reporter_email);
      this.validation.organization_name = validators.validateText("Organization name", this.organization_name);
      if (this.incident_type === 'WEB_APPLICATION_ATTACK')
        this.validation.hostingCountry = validators.validateText("Country", this.hostingCountry);
      this.validation.detection_date = this.detection_date != null ? {
        status: true,
        message: "valid"
      } : {status: false, message: "Invalid detection date"};
      this.validation.incident_description = validators.validateText("Incident description", this.incident_description);
      return this.validation.first_name.status && this.validation.last_name.status && this.validation.organization_sector.status && this.validation.phone_number.status && this.validation.reporter_email.status &&
          this.validation.organization_name.status && this.validation.detection_date.status && this.validation.incident_description.status
          && (this.incident_type !== 'WEB_APPLICATION_ATTACK' || this.validation.hostingCountry.status);
    },

    reportIncident(e) {
      e.preventDefault();
      var incidentData = {
        businessSector: this.organization_sector,
        email: this.reporter_email,
        firstName: this.first_name,
        lastName: this.last_name,
        incidentDescription: this.incident_description,
        phoneNumber: this.phone_number,
        organizationName: this.organization_name,
        incidentType: this.incident_type,
        incidentTime: new Date(this.detection_date).toISOString(),
        country: this.hostingCountry,
      };
      if (incidentData.incidentType === "other") {
        incidentData.incidentType = "OTHER";
      }
      if (this.validationReportIncidentStatus()) {
        this.disableSubmit = true;
        axios.post(`${process.env.VUE_APP_BASE_URL}incident/insert`, incidentData)
            .then((response) => {
              this.applicationId = response.data;
              this.reporter_email = null;
              this.first_name = null;
              this.last_name = null;
              this.incident_description = null;
              this.phone_number = null;
              this.organization_name = null;
              this.organization_sector = null;
              this.incident_type = null;
              this.anotherIncident_type = null;
              this.detection_date = null;
              this.responseSuccess = true;
              this.hostingCountry = null;
              setTimeout(() => this.responseSuccess = !this.responseSuccess, 12000);
              this.disableSubmit = false;
            })
            .catch(error => {
              this.responseError = !this.responseError;
              setTimeout(() => this.responseError = !this.responseError, 12000);
              this.errorMessage = error.message;
              this.disableSubmit = false;
              console.error("There was an error!", error);
            });
      }
    },
    validatePhoneNumber() {
      const validationRegex = /^\d{10}$/;
      if (this.phone_number.match(validationRegex)) {
        this.isValidPhoneNumber = true;
      } else {
        this.isValidPhoneNumber = false;
      }
    },
    async loadCountries() {
      const response = await axios.get(`${process.env.VUE_APP_BASE_URL}address/countries/`);
      this.countries = response.data.map(item => {
        return {display: item.name, value: item.name};
      });
    },
  },
  async mounted() {
    this.loadIncidentType();
    this.loadOrganizationSector();
    await this.loadCountries();
  }
};
</script>
